export const COMMENTS_LIMIT = 10

export const LINEITEM_TEMPLATE = ['claim_status_payer', 'detailed_claim_status']

export const EntityTemplateInfo = [
  'claim_status_payer',
  'detailed_claim_status',
  'insurer_claim_id_payer_ivr',
  'coverage_order',
  'billed_amount_payer_ivr',
  'claim_received_date_payer_ivr',
  'claim_processed_date_payer_ivr',
  'discount_amount_payer_ivr',
  'total_covered_payer_ivr',
  'total_not_covered_payer_ivr',
  'plan_paid_amount_payer_ivr',
  'payment_method_payer_ivr',
  'payment_date_payer_ivr',
  [
    'payment_posted_date_payer_ivr',
    'ach_payment_date_payer_ivr',
    'check_payment_date_payer_ivr',
    'eft_payment_date_payer_ivr',
  ],
  [
    'payment_reference_payer_ivr',
    'ach_payment_reference_payer_ivr',
    'check_payment_reference_payer_ivr',
    'eft_payment_reference_payer_ivr',
  ],
  'remittance_advice_date_payer_ivr',
  'coinsurance_payment_amount_payer_ivr',
  'applied_to_deductible_amount_payer_ivr',
  'patient_responsibile_amount_payer_ivr',
  'provider_responsibility_amount_payer_ivr',
  'tpa_name',
  'tpa_phone_number',
]

export const EntityTemplateAppealInfo = [
  'appeal_status',
  'appeal_receipt_date',
  'appeal_decision_date',
  'appeal_case_number',
  'confirmed_claim_partially_paid',
  'confirmed_no_additional_appeal_payment',
  'confirmed_next_level_appeal_available',
  'confirmed_final_level_appeal',
  'appeal_determination_date',
  'appeal_determination_letter_date',
  'appeal_document_number_asc'
]
